module.exports = __webpack_public_path__ + "static/media/donbosco21.ca5ab21a.jpg";